
/**
 * @summary - Component that Provides Add PPM SCHEDULE functionality
 * @autor vengateshwaran k
 * @since 2024-06-21
 */
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";
import axios from "axios";
import {
  addMonths,
  addWeeks,
  endOfYear,
  format,
  getDate,
  getMonth,
  getWeek,
  getYear,
  parse,
  startOfDay, parseISO, isAfter, isEqual, isBefore,
  endOfMonth,
  getDaysInMonth
} from "date-fns";
import React, { useEffect, useMemo, useState, useRef } from "react";
import PpmPlannerRepository from "../../api/repositories/ppmPlannerRepository";
import ReArrangeLabel from "../../components/commoncomponents/ReArrangeLabel";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import { getAuthToken } from "../../utility/tokenUtility";
import CustomDatePicker from "../commoncomponents/CustomDatePicker";
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import CancelWorkOrder from "./cancelWorkOrder";
import PageLoader from "../commoncomponents/PageLoader";
import PremitiveMaintenanceRepository from "../../api/repositories/premitiveMaintenanceRepository"

const AddPPM = ({
  companyId,
  selectedValues,
  rows,
  showAddRowDialog = false,
  onCloseAddRowDialog,
  selectedRowsisEdit,
  workGroup,
  onRowAdded,
  year,
  approvedBy,
  proposedBy,
  serviceType,
  facilityId,
  PopPupLoading
}) => {
  const AddRowDialogue = ({
    companyId,
    facilityId,
    selectedRowsisEdit,
    open,
    onClose,
    onConfirm,
    selectedValues,
    row,
    year,
    approvedBy,
    proposedBy,
    workGroup,
    serviceType,
    PopPupLoading
  }) => {
    const [isFilledAllMandatoryField, setIsFilledAllMandatoryField] = useState(false);
    const [assetDescriptionPPM, setAssetDescriptionPPM] = useState();
    const [typecodePPM, setTypeCodePPM] = useState();
    const [underwarrenty, setUnderWarrenty] = useState("No");
    const [isImaging, setIsImaging] = useState("No");
    const [period, setPeriod] = useState();
    const [scheduledFrequency, setScheduledFrequency] = useState(1);
    const [targetDate, setTargetDate] = useState();
    const [nextPpmDate, setNextPpmDate] = useState();
    const [responseType, setResponseType] = useState();
    const [allAsset, setAllAsset] = useState();
    const [taskCodeOptions, setTaskCodeOptions] = useState();
    const [assetNo, setAssetNo] = useState();
    const [taskCode, setTaskCode] = useState();
    const [responseTypeOptions, setResponseTypeOptions] = useState();
    const [periodOptions, setPeriodOptions] = useState();
    const [vendorOptions, setVendorOptions] = useState();
    const [employeeOptions, setEmployeeOptions] = useState([]);
    const [vendor, setVendor] = useState();
    const [confirmationSaveDialogOpen, setConfirmationSaveDialogOpen] = useState(false);
    const [errors, setErrors] = useState({}); // State to track validation errors
    const [isChanged, setIsChanged] = useState(false)
    const [saveCount, setSaveCount] = useState(0);
    const runOnce = useRef(false);
    const [loading, setLoading] = useState(PopPupLoading);
    const checkService = serviceType?.label === 'FEMS' ? "fem" : "bem";
    const [IsAssigneorTaskCodeChange, setisAssigneorTaskCodeChange] = useState(false);


    const fetchOptions = async () => {
      try {
        if (serviceType?.label === 'BEMS') {
          const assetNo = await PpmPlannerRepository.getBemsAssetNoDetails(
            facilityId,
            workGroup?.id
          );
          setAllAsset(assetNo);
          const taskCode = await PpmPlannerRepository.getBemsTaskCodeDetails(
            facilityId,
            workGroup?.id
          );
          setTaskCodeOptions(taskCode);

          const dropDownLists =
            await PpmPlannerRepository.ppmBemsScheduleDropDownList(
              facilityId,
              companyId
            );
          const periodOptionsRearrange = await ReArrangeLabel(
            dropDownLists?.data?.bemppmintervaltypes,
            "intervaltypedesc",
            "label"
          );
          setPeriodOptions(periodOptionsRearrange?.filter((item) => (item.label === "Weeks" || item.label === "Months")));
          if (!selectedValues?.period) {
            setPeriod(
              periodOptionsRearrange?.find((item) => item.label === "Weeks")
            );
          }

          const responseOptionsRearrange = await ReArrangeLabel(
            dropDownLists?.data?.bemworespondtypes,
            "respondtype",
            "label"
          );
          setResponseTypeOptions(responseOptionsRearrange);
          if (!selectedValues?.respondtype) {
            setResponseType(
              responseOptionsRearrange?.find((item) => item.label === "Inhouse")
            );
          }
        } else {
          const assetNo = await PpmPlannerRepository.getAssetNoDetails(
            facilityId,
            workGroup?.id
          );
          setAllAsset(assetNo);
          const taskCode = await PpmPlannerRepository.getTaskCodeDetails(
            facilityId,
            workGroup?.id
          );
          setTaskCodeOptions(taskCode);


          const dropDownLists =
            await PpmPlannerRepository.ppmscheduleDropDownList(
              facilityId,
              companyId
            );
          const periodOptionsRearrange = await ReArrangeLabel(
            dropDownLists?.data?.femppmintervaltypes,
            "intervaltypedesc",
            "label"
          );
          setPeriodOptions(periodOptionsRearrange?.filter((item) => (item.label === "Weeks" || item.label === "Months")));
          if (!selectedValues?.period) {
            setPeriod(
              periodOptionsRearrange?.find((item) => item.label === "Weeks")
            );
          }

          const responseOptionsRearrange = await ReArrangeLabel(
            dropDownLists?.data?.femworespondtypes,
            "respondtype",
            "label"
          );
          setResponseTypeOptions(responseOptionsRearrange);
          if (!selectedValues?.respondtype) {
            setResponseType(
              responseOptionsRearrange?.find((item) => item.label === "Inhouse")
            );
          }
        }

        const vendorOptions = await PpmPlannerRepository.getVendorList(
          companyId
        );
        setVendorOptions(vendorOptions);

        const assigneeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
        if (assigneeList?.status !== 'error') {
          setEmployeeOptions(assigneeList);
        }
      } catch (e) {
        console.log(e);
      }
      finally {
        runOnce.current = true;
      }
    };


    useEffect(() => {
      if (open) {

        if (!runOnce.current) {
          fetchOptions();
        }
      }
    }, [open]);

    // Function to move the matching object to the first index
    async function moveLabelToFirstIndex(array, labelToMove) {
      // Find the index of the object with the matching label
      const index = array.findIndex((obj) => obj.label === labelToMove);

      // If the object is found and is not already at the first index
      if (index > 0) {
        // Remove the object from its original position
        const [item] = array.splice(index, 1);

        // Insert the object at the first index
        array.unshift(item);
      }

      return array;
    }

    const fetchEditOptions = async () => {
      try {
        setLoading(true);
        if (serviceType?.label === 'FEMS') {
          const dropDownLists =
            await PpmPlannerRepository.ppmscheduleDropDownList(
              facilityId,
              companyId
            );
          const periodOptionsRearrange = await ReArrangeLabel(
            dropDownLists?.data?.femppmintervaltypes,
            "intervaltypedesc",
            "label"
          );
          setPeriodOptions(periodOptionsRearrange?.filter((item) => (item.label === "Weeks" || item.label === "Months")));
          const responseOptionsRearrange = await ReArrangeLabel(
            dropDownLists?.data?.femworespondtypes,
            "respondtype",
            "label"
          );
          setResponseTypeOptions(responseOptionsRearrange);
          const vendorOption = await PpmPlannerRepository.getVendorList(
            companyId
          );
          const employeeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);

          if (selectedValues?.targetdate && selectedRowsisEdit) {
            if (selectedValues) {
              setAssetNo({ label: selectedValues?.assetno || "", value: selectedValues?.assetno || "", id: selectedValues?.assetid || "" });
              setAssetDescriptionPPM(selectedValues?.assetdesc || "")
              setTypeCodePPM(selectedValues?.typecode || "")
              setTaskCode({ id: selectedValues?.femtaskdetailsId || "", label: `${selectedValues?.taskcode || ""}-${selectedValues?.taskdesc || ""}`, value: selectedValues?.taskcode });
              setTargetDate(selectedValues?.targetdate);
              setNextPpmDate(selectedValues?.nextppmdate);
              setScheduledFrequency(selectedValues?.scheduledfrequency);
              setPeriod(periodOptionsRearrange?.find((item) => item?.label === selectedValues?.period));
              setResponseType(responseOptionsRearrange?.find((item) => item?.label === selectedValues?.respondtype));

            }

            if (selectedValues?.vendorid && selectedValues?.respondtype === "Outsource") {
              setVendor(vendorOption?.find((item) => item?.id === selectedValues?.vendorid));
            } else if (selectedValues?.staffid && selectedValues?.respondtype === "Inhouse") {
              setVendor(employeeList?.find((item) => item?.id === selectedValues?.staffid));
            }
          }
        } else {
          const taskCode = await PpmPlannerRepository.getBemsTaskCodeDetails(
            facilityId,
            workGroup?.id
          );
          const dropDownLists =
            await PpmPlannerRepository.ppmBemsScheduleDropDownList(
              facilityId,
              companyId
            );
          const periodOptionsRearrange = await ReArrangeLabel(
            dropDownLists?.data?.bemppmintervaltypes,
            "intervaltypedesc",
            "label"
          );
          setPeriodOptions(periodOptionsRearrange?.filter((item) => (item.label === "Weeks" || item.label === "Months")));
          const responseOptionsRearrange = await ReArrangeLabel(
            dropDownLists?.data?.bemworespondtypes,
            "respondtype",
            "label"
          );
          setResponseTypeOptions(responseOptionsRearrange);
          const vendorOption = await PpmPlannerRepository.getVendorList(
            companyId
          );
          const employeeList = await PremitiveMaintenanceRepository.getStaffDetails(facilityId);
          if (selectedValues?.targetdate && selectedRowsisEdit) {

            if (selectedValues) {

              setTargetDate(selectedValues?.targetdate);
              setNextPpmDate(selectedValues?.nextppmdate);
              setAssetNo({ label: selectedValues?.assetno || "", value: selectedValues?.assetno || "", id: selectedValues?.assetid || "" });
              setAssetDescriptionPPM(selectedValues?.assetdesc || "")
              setTypeCodePPM(selectedValues?.typecode || "")
              setTaskCode({ id: selectedValues?.bemtaskdetailsId || "", label: `${selectedValues?.taskcode || ""}-${selectedValues?.taskdesc || ""}`, value: selectedValues?.taskcode });
              setScheduledFrequency(selectedValues?.scheduledfrequency);
              setPeriod(periodOptionsRearrange?.find((item) => item?.label === selectedValues?.period));
              setUnderWarrenty(selectedValues?.isunderwarranty === true ? "Yes" : "No" || "No")
              setIsImaging(selectedValues?.isimagingequipment === true ? "Yes" : "No" || "No")
              setTypeCodePPM(selectedValues?.typecode || "");
            }

            if (selectedValues?.respondtype) {
              setResponseType(responseOptionsRearrange?.find((item) => item?.label === selectedValues?.respondtype));
            }
            if (selectedValues?.vendorid && selectedValues?.respondtype === "Outsource") {
              setVendor(vendorOption?.find((item) => item?.id === selectedValues?.vendorid));
            } else if (selectedValues?.staffid && selectedValues?.respondtype === "Inhouse") {
              setVendor(employeeList?.find((item) => item?.id === selectedValues?.staffid));
            }
          }

        }

      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };


    useEffect(() => {
      if (open) {
        fetchEditOptions();
      }
    }, [selectedValues]);

    const onChangeHandle = (value, type) => {
      const currentYear = new Date().getFullYear();

      const adjustDateToCurrentYear = (date) => {
        let year = getYear(date);
        let month = getMonth(date);
        let day = getDate(date);

        if (year < currentYear) {
          year = currentYear;
          date = new Date(year, month, day);
        }

        return date;
      };

      if (period) {
        var periodForPpm = period?.label;
      }
      if (type === "targetdate") {
        let Tdate = format(parse(value, "dd/MM/yyyy", new Date()), "yyyy/MM/dd");
        let year = getYear(Tdate);
        let month = getMonth(Tdate);
        let date = getDate(Tdate);
        let scheduledFrequencyPeriod = scheduledFrequency || 0;

        let nextPPMDate =
          periodForPpm === "Months"
            ? addMonths(new Date(year, month, date), scheduledFrequencyPeriod)
            : addWeeks(new Date(year, month, date), scheduledFrequencyPeriod);

        nextPPMDate = adjustDateToCurrentYear(nextPPMDate);
        const formattedDate = format(nextPPMDate, "dd/MM/yyyy");
        setNextPpmDate(formattedDate);
      } else if (type === "scheduledfrequency" && targetDate) {
        let Tdate = format(parse(targetDate, "dd/MM/yyyy", new Date()), "yyyy/MM/dd");
        let year = getYear(Tdate);
        let month = getMonth(Tdate);
        let date = getDate(Tdate);
        let scheduledFrequencyPeriod = value || 0;

        let nextPPMDate =
          periodForPpm === "Months"
            ? addMonths(new Date(year, month, date), scheduledFrequencyPeriod)
            : addWeeks(new Date(year, month, date), scheduledFrequencyPeriod);

        nextPPMDate = adjustDateToCurrentYear(nextPPMDate);
        const formattedDate = format(nextPPMDate, "dd/MM/yyyy");
        setNextPpmDate(formattedDate);
      } else if (type === "period" && targetDate) {
        let Tdate = format(parse(targetDate, "dd/MM/yyyy", new Date()), "yyyy/MM/dd");
        let year = getYear(Tdate);
        let month = getMonth(Tdate);
        let date = getDate(Tdate);
        let scheduledFrequencyPeriod = scheduledFrequency || 0;

        let nextPPMDate =
          value?.label === "Months"
            ? addMonths(new Date(year, month, date), scheduledFrequencyPeriod)
            : value?.label === "Weeks"
              ? addWeeks(new Date(year, month, date), scheduledFrequencyPeriod)
              : addMonths(new Date(year, month, date), 0);

        nextPPMDate = adjustDateToCurrentYear(nextPPMDate);
        const formattedDate = format(nextPPMDate, "dd/MM/yyyy");
        setNextPpmDate(formattedDate);
      }
    };


    const handleFieldChange = (field, newValue, isTrue) => {
      if ((newValue?.label || isTrue) && field !== "vendor" && field !== "taskCode") {
        setIsFilledAllMandatoryField(false);
        setIsChanged(true);
      }
      // console.log(newValue, "new value");

      switch (field) {

        case "assetNo":
          setAssetNo({ ...newValue, label: newValue?.value });
          setAssetDescriptionPPM(newValue?.assetdesc || "");
          setTypeCodePPM(newValue?.typecode || "");
          setIsImaging(newValue?.isimagingequipment === true ? "Yes" : "No");
          if (serviceType?.value === "BEMS") {
              setUnderWarrenty(newValue?.isunderwarranty === true ? "Yes" : "No")
              if (newValue?.isunderwarranty === false && newValue?.isimagingequipment === true) {
                setPeriod({ id: 2, label: "Months", value: "Months" })
                setScheduledFrequency(newValue?.isunderwarranty === true ? 1 : newValue?.intervalunit || "");
              }

          }

          setResponseType({
            id: newValue?.[`${checkService}assetppmstatusId`] || 2,
            label: newValue?.[`${checkService}assetppmstatusId`] === 2
              ? "Inhouse"
              : newValue?.[`${checkService}assetppmstatusId`] === 1
                ? "Outsource"
                : "Inhouse",
            value: newValue?.[`${checkService}assetppmstatusId`] === 2
              ? "Inhouse"
              : newValue?.[`${checkService}assetppmstatusId`] === 1
                ? "Outsource"
                : "Inhouse"
          });
          if (newValue?.value === "") {
            setAssetDescriptionPPM("");
            if (serviceType?.value === "BEMS") {
              setTypeCodePPM("");
              setScheduledFrequency(1);
              setUnderWarrenty("")
              setPeriod({ id: 1, label: "Weeks", value: "Weeks" })
            }

          }
          if (newValue?.label !== "") {
            setErrors({ ...errors, assetNo: null });
          }
          break;
        case "assetDescriptionPPM":
          setAssetDescriptionPPM(newValue);
          break;
        case "typecodePPM":
          setTypeCodePPM(newValue);
          break;
        case "responseType":
          setResponseType(newValue);
          if (newValue?.label !== "") {
            setErrors({ ...errors, responseType: null });
            setVendor({ label: '', value: '' });
          }
          break;
        case "vendor":
          setVendor(newValue);

          if (newValue?.label !== "") {
            setisAssigneorTaskCodeChange(true);
            setErrors({ ...errors, vendor: null });
          }
          break;
        case "taskCode":
          setTaskCode({ ...newValue });
          // setTaskCode({ ...newValue, label: newValue?.taskcode ? newValue?.taskcode : "" });
          if (newValue?.label !== "") {
            setisAssigneorTaskCodeChange(true);
            setErrors({ ...errors, taskCode: null });
          }
          break;
        case "targetDate":
          onChangeHandle(newValue, "targetdate");
          setTargetDate(newValue);
          setErrors({ ...errors, targetDate: null });
          break;
        case "scheduledFrequency":
          if (newValue > 0) {
            setErrors({ ...errors, scheduledFrequency: null });
          }
          setScheduledFrequency(Number(newValue) + 0);
          onChangeHandle(Number(newValue) + 0, "scheduledfrequency");
          //   setIsFilledAllMandatoryField(false);
          //   setIsOnchange(true);
          //   setIsChanged(true);
          //   setScheduledFrequency(Number(newValue) + 0);
          break;
        case "period":
          onChangeHandle(newValue, "period");
          setPeriod(newValue);
          if (newValue?.label !== "") {
            setErrors({ ...errors, period: null });
          }
          break;
        case "nextPpmDate":
          setNextPpmDate(newValue);
          break;
        default:
          break;
      }
    };


    //This GeneratedDates Function For calculate the Next PPM date dynamically while changing the target date
    const generateDates = (
      start,
      frequency,
      ppmScheduleId,
      startFromDate,
      schFrequency,
    ) => {

      const getCurrentDate = new Date();
      const currentYear = getCurrentDate.getFullYear();

      // Use the provided start date as initialDate
      let initialDate = new Date(start);

      //Generate dates till end of next year
      const endDate = new Date(currentYear + 1, 11, 31);

      //Generate dates till end of current year

      //   const endDate = new Date(currentYear, 11, 31);

      const datesArray = [];
      const originalDay = initialDate.getDate();

      let weekNumber = getWeek(initialDate);
      let schTrackYear = format(initialDate, "yyyy");

      const rows =
        serviceType?.label === "FEMS"
          ? {
            isdeleted: false,
            week: "",
            trackyear: "",
            startfromdate: "",
            targetdate: "",
            femppmscheduledetails: {
              id: ppmScheduleId,
            },
            femtaskdetailsId: taskCode?.id,
            ...(responseType?.label === "Inhouse"
              ? { staffid: vendor?.id || "" }
              : { vendorid: vendor?.id || "" }),
          }
          : {
            isdeleted: false,
            week: "",
            trackyear: "",
            startfromdate: "",
            targetdate: "",
            bemppmscheduledetails: {
              id: ppmScheduleId,
            },
            bemtaskdetailsId: taskCode?.id,
            ...(responseType?.label === "Inhouse"
              ? { staffid: vendor?.id || "" }
              : { vendorid: vendor?.id || "" }),
          };

      // Generate dates till endDate (2026 included)
      let currentDate = initialDate;

      while (currentDate <= endDate) {
        if (currentDate >= new Date(startFromDate)) {
          datesArray.push({
            ...rows,
            targetdate: format(currentDate, "yyyy-MM-dd'T'HH:mm:ss"),
            week: weekNumber,
            trackyear: schTrackYear,
            startfromdate: startFromDate,
          });
        }

        if (frequency === "Months") {
          // Add months based on schedule frequency
          currentDate = addMonths(
            currentDate,
            schFrequency === 0 ? 1 : schFrequency
          );

          // Handle month-end edge cases
          const lastDayOfCurrentMonth = endOfMonth(currentDate).getDate();
          if (originalDay > lastDayOfCurrentMonth) {
            currentDate = endOfMonth(currentDate);
          } else {
            currentDate.setDate(originalDay);
          }
        } else {
          // Weekly frequency
          currentDate = addWeeks(
            currentDate,
            schFrequency === 0 ? 1 : schFrequency
          );
        }

        weekNumber = getWeek(currentDate);
        schTrackYear = format(currentDate, "yyyy");
      }

      return datesArray;
    };


    //This is the Handlesave function for send the API Payload in both Save and Update method
    const handleSave = async () => {
      try {
        if (isChanged) {
          const getTaskDestails = serviceType?.label === "FEMS" ? "femtaskdetailsId" : "bemtaskdetailsId";

          if (saveCount === 0) {
            setSaveCount(1);
            const withoutTimeZoneNextPpm = parse(
              targetDate,
              "dd/MM/yyyy",
              new Date()
            );
            const parsedTargetDate = startOfDay(withoutTimeZoneNextPpm);
            const finalTargetDate = format(
              parsedTargetDate,
              "yyyy-MM-dd'T'HH:mm:ss"
            );
            const finalTargetDate1 = format(
              parsedTargetDate,
              "yyyy/MM/dd HH:mm:ss"
            );

            const withoutTimeZone = parse(nextPpmDate, "dd/MM/yyyy", new Date());
            const parsedNextPpmDate = startOfDay(withoutTimeZone);
            const finalNextPPMDate = format(
              parsedNextPpmDate,
              "yyyy-MM-dd'T'HH:mm:ss"
            );
            const date = new Date(withoutTimeZoneNextPpm);
            // Get the week number
            const weekNumber = getWeek(date);
            let requestBody = serviceType?.label === 'FEMS' ? {
              femassetregister: {
                id: assetNo?.id,
                assetno: assetNo?.label,
                assetdesc: assetNo?.assetdesc,
              },

              femtaskdetails: {
                effectivefrom: finalTargetDate,
                id: taskCode?.id,
                taskcode: taskCode?.label,
              },
              femworkgroupdetails: {
                id: workGroup?.id,
                isdeleted: false,
                facilityid: facilityId,
                wgcode: workGroup?.label,
                wgdesc: workGroup?.wgdesc,
                serviceid: serviceType?.id,
              },

              femassethistorymaintenances: [
                {
                  id: year?.id,
                  isdeleted: false,
                  historicalmaintenanceyear: year?.label,
                  breakdowncost: 0,
                  ppmcost: 0,
                  totalmaintenancecost: 0,
                  femassetregister: "string",
                },
              ],
              femppmintervaltypeId: period?.id,
              femworespondtypeId: responseType?.id,
              facilityid: facilityId,
              intervalunit: scheduledFrequency,
              approvedbyhss: proposedBy,
              approvedbymoh: approvedBy,
              startperiod: weekNumber,
              schyear: year?.label,
              startfromdate: finalTargetDate,
              nexttargetdate: finalNextPPMDate,
              isdeleted: false,
              scheduleyearid: year?.id,
              ...(responseType?.label === 'Inhouse'
                ? { staffid: vendor?.id } // Add staffid when responseType is Inhouse
                : { vendorid: vendor?.id }), // Add vendorid otherwise
            } :
              {
                bemassetregister: {
                  id: assetNo?.id,
                  assetno: assetNo?.label,
                  assetdesc: assetNo?.assetdesc,
                },

                bemtaskdetails: {
                  effectivefrom: finalTargetDate,
                  id: taskCode?.id,
                  taskcode: taskCode?.label,
                  Isactive: true
                },
                bemworkgroupdetails: {
                  id: workGroup?.id,
                  isdeleted: false,
                  facilityid: facilityId,
                  wgcode: workGroup?.label,
                  wgdesc: workGroup?.wgdesc,
                  serviceid: serviceType?.id,
                },

                bemassethistorymaintenances: [
                  {
                    id: year?.id,
                    isdeleted: false,
                    historicalmaintenanceyear: year?.label,
                    breakdowncost: 0,
                    ppmcost: 0,
                    totalmaintenancecost: 0,
                    bemassetregister: "string",
                  },
                ],
                facilityid: facilityId,
                intervalunit: scheduledFrequency,
                approvedbyhss: proposedBy,
                approvedbymoh: approvedBy,
                startperiod: weekNumber,
                schyear: year?.label,
                startfromdate: finalTargetDate,
                nexttargetdate: finalNextPPMDate,
                isdeleted: false,
                scheduleyearid: year?.id,
                ...(responseType?.label === 'Inhouse'
                  ? { staffid: vendor?.id } // Add staffid when responseType is Inhouse
                  : { vendorid: vendor?.id }), // Add vendorid otherwise
                bemppmintervaltypeId: period?.id,
                bemworespondtypeId: responseType?.id,
              };
            let requestBodyForUpdate = serviceType?.label === 'FEMS' ? {
              facilityid: facilityId,
              intervalunit: scheduledFrequency,
              startperiod: weekNumber,
              approvedbyhss: proposedBy,
              approvedbymoh: approvedBy,
              schyear: year?.value,
              startfromdate: finalTargetDate,
              nexttargetdate: finalNextPPMDate,
              lastscheduledate: "2023-07-28T00:00:00",
              scheduleyearid: year?.id,
              ...(responseType?.label === 'Inhouse'
                ? { staffid: vendor?.id } // Add staffid when responseType is Inhouse
                : { vendorid: vendor?.id }), // Add vendorid otherwise
              femassetregisterId: assetNo?.id,
              femtaskdetailsId: taskCode?.id,
              femppmintervaltypeId: period?.id,
              femworespondtypeId: responseType?.id,
              femppmscheduletracks: [],
              isdeleted: false,
              id: selectedValues?.id,
              timestamp: selectedValues?.timestamp
            } : {
              facilityid: facilityId,
              intervalunit: scheduledFrequency,
              startperiod: weekNumber,
              approvedbyhss: proposedBy,
              approvedbymoh: approvedBy,
              schyear: year?.value,
              startfromdate: finalTargetDate,
              nexttargetdate: finalNextPPMDate,
              lastscheduledate: "2023-07-28T00:00:00",
              scheduleyearid: year?.id,
              ...(responseType?.label === 'Inhouse'
                ? { staffid: vendor?.id } // Add staffid when responseType is Inhouse
                : { vendorid: vendor?.id }), // Add vendorid otherwise
              bemassetregisterId: assetNo?.id,
              bemtaskdetailsId: taskCode?.id,
              bemppmintervaltypeId: period?.id,
              bemworespondtypeId: responseType?.id,
              bemppmscheduletracks: [],
              isdeleted: false,
              id: selectedValues?.id,
              timestamp: selectedValues?.timestamp
            };
            const token = getAuthToken("id_token");
            if (isChanged) {
              let response;
              if (serviceType?.label === 'FEMS') {
                response = await axios.request({
                  url:
                    selectedValues !== null &&
                      Object.keys(selectedValues)?.length !== 0
                      ? `${FemsGraph}/api/femppmscheduledetails/${selectedValues?.id}`
                      : `${FemsGraph}/api/femppmscheduledetails`,
                  method:
                    selectedValues !== null &&
                      Object.keys(selectedValues)?.length !== 0
                      ? "put"
                      : "post",
                  headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "text/plain",
                    "Content-Type": "application/json",
                  },
                  data:
                    selectedValues !== null &&
                      Object.keys(selectedValues)?.length !== 0 &&
                      selectedValues !== undefined
                      ? requestBodyForUpdate
                      : requestBody,
                });
              } else {
                response = await axios.request({
                  url:
                    selectedValues !== null &&
                      Object.keys(selectedValues)?.length !== 0
                      ? `${BemsGraph}/api/bemppmscheduledetails/${selectedValues?.id}`
                      : `${BemsGraph}/api/bemppmscheduledetails`,
                  method:
                    selectedValues !== null &&
                      Object.keys(selectedValues)?.length !== 0
                      ? "put"
                      : "post",
                  headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: "text/plain",
                    "Content-Type": "application/json",
                  },
                  data:
                    selectedValues !== null &&
                      Object.keys(selectedValues)?.length !== 0 &&
                      selectedValues !== undefined
                      ? requestBodyForUpdate
                      : requestBody,
                });
              }

              if (response.status >= 200 && response.status <= 204) {
                if (
                  selectedValues === null ||
                  selectedValues === undefined ||
                  Object.keys(selectedValues)?.length === 0
                ) {
                  const generatedDates = generateDates(
                    finalTargetDate1,
                    period?.label, // Frequency (e.g., "Weeks" or "Months")
                    response?.data?.id,
                    finalTargetDate,
                    scheduledFrequency,
                    row?.[`${getTaskDestails}`],
                    vendor?.id || ""
                  );

                  if (generatedDates) {
                    const setTracks = generatedDates?.map(async (item) => {
                      const updatePpmScheduleTracks = serviceType?.label === 'FEMS' ?
                        await PpmPlannerRepository.addPpmscheduleTracks(item) : await PpmPlannerRepository.addBemsPpmscheduleTracks(item);
                      return updatePpmScheduleTracks;
                    });

                    const updatePpmScheduleTracksInsert = await Promise.all(
                      setTracks
                    );
                    const allStatusForInsert = updatePpmScheduleTracksInsert.every(
                      (result) => result.status <= 204
                    );
                    if (allStatusForInsert) {
                      setSaveCount(1);
                      onClose();
                    } else {
                      onClose();
                    }
                  }
                } else {
                  let isDeleteTracks = false;
                  if (selectedValues !== null || selectedValues !== undefined) {
                    const updatePpmScheduleTracksDelete = serviceType?.label === "FEMS" ?
                      await PpmPlannerRepository.addPpmscheduleTracksDelete(
                        selectedValues?.id
                      ) :
                      await PpmPlannerRepository.addBemsPpmscheduleTracksDelete(
                        selectedValues?.id
                      );
                    if (updatePpmScheduleTracksDelete?.status <= 204) {
                      isDeleteTracks = true
                    }
                  }

                  if (isDeleteTracks === true) {
                    const generatedDates = generateDates(
                      finalTargetDate1,
                      period?.label,
                      response?.data?.id,
                      finalTargetDate,
                      scheduledFrequency,
                      row?.[`${getTaskDestails}`],
                    );
                    if (generatedDates) {

                      const currentDate = new Date();
                      // const filteredDates = generatedDates.filter(item => new Date(item.targetdate) > currentDate);
                      const filteredDates = generatedDates.filter(item => new Date(item.targetdate) >= new Date(finalTargetDate));
                      const setTracks = filteredDates?.map(async (item) => {
                        const updatePpmScheduleTracks =
                          serviceType?.label === 'FEMS' ?
                            await PpmPlannerRepository.addPpmscheduleTracks(item) : await PpmPlannerRepository.addBemsPpmscheduleTracks(item);
                        return updatePpmScheduleTracks;
                      });
                      const updatePpmScheduleTracksUpdate = await Promise.all(
                        setTracks
                      );
                      const allStatusForUpdate =
                        updatePpmScheduleTracksUpdate.every(
                          (result) => result.status <= 204
                        );
                      if (allStatusForUpdate) {
                        onClose();
                      }
                    }
                  }
                }
              } else if (response.status === 401) {

              }
            }
          }
        } else if (IsAssigneorTaskCodeChange) {
          const payload = {
            staffid: responseType?.value === "Inhouse" ? vendor?.id : null,
            vendorid: responseType?.value === "Outsource" ? vendor?.id : null,
            taskcodeid: taskCode?.id || ""
          }
          await PpmPlannerRepository.updatePPMplannerAssigneorTaskCode(selectedValues?.id, payload.staffid, payload.vendorid, payload.taskcodeid, serviceType?.label);
        }

      } catch (error) {
        if (error.response && error.response.status === 401) {
          console.log(error.response);
        } else {
          console.log("data not inserted properly");
        }
      }
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      try {
        const newErrors = {};
        if (!assetNo?.label) newErrors.assetNo = "Asset No is required";
        if (!taskCode?.label) newErrors.taskCode = "Task Code is required";
        if (!targetDate) newErrors.targetDate = "Target Date is required";
        if (!period?.label) newErrors.period = "Period is required";
        if (!responseType?.label) newErrors.responseType = "Respond Type is required";
        if (scheduledFrequency == 0) newErrors.scheduledFrequency = "Scheduled Frequency should be greater than zero";

        if (Object.keys(newErrors)?.length > 0) {
          setErrors(newErrors);
        } else {
          setLoading(true);

          await handleSave()
          setLoading(false);
          onClose();
        }
      }
      catch (e) {
        console.error(e);

      }
    }


    return (
      <>
        <Dialog
          open={open}
          // onClose={onClose}
          onClose={(_, reason) => {
            if (reason !== "backdropClick") {
              onClose();
            }
          }}
          sx={{
            "& .MuiPaper-root": {
              borderRadius: "16px",
              height: "520px", // Adjust the height as per your requirement
            }
          }}
        >
          <PageLoader open={loading} />

          <DialogTitle>
            {
              <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>
                {selectedValues?.id ? "Edit Planner" : "Add Planner"}
              </Typography>
            }
          </DialogTitle>
          <DialogContent>
            {isFilledAllMandatoryField && (
              <Typography sx={{ color: "red" }}>
                Please Fill All Mandatory Fields(*)
              </Typography>
            )}
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
                <CustomTextFieldWithSearch
                  autoFocus={true}
                  isMandatoryField={true}
                  label="Asset No"
                  id="assetno"
                  value={assetNo}
                  error={!!errors?.assetNo}
                  errorMessage={errors.assetNo}
                  disabled={selectedValues?.assetno ? true : false}
                  options={allAsset?.map((item) => { return { ...item, label: `${item?.label}-${item?.assetdesc}` } })?.sort((a, b) => a.label.localeCompare(b.label))}
                  onChange={(newValue) => handleFieldChange("assetNo", newValue)}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <CustomTextField
                  label="Asset Description"
                  value={assetDescriptionPPM}
                  isRefilByOtherField={true}
                  placeholder={false}
                  onChange={(newValue) => handleFieldChange("assetDescriptionPPM", newValue)}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <CustomSelectInput
                  modal={open}
                  id="rental-status-label"
                  label="Respond Type"
                  isMandatoryField={true}
                  error={!!errors?.responseType}
                  errorMessage={errors.responseType}
                  value={responseType}
                  options={responseTypeOptions || []}
                  onChange={(newValue) => handleFieldChange("responseType", newValue)}
                  disabled={true}
                />
              </Grid>
              {serviceType?.value === "BEMS" && (
                <>
                  <Grid item xs={6} md={6}>
                    <CustomTextField
                      label="Type Code"
                      value={typecodePPM}
                      isRefilByOtherField={true}
                      placeholder={false}
                      onChange={(newValue) => handleFieldChange("typecodePPM", newValue)}
                    />
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <CustomTextField
                      label="Under Warrenty"
                      value={underwarrenty}
                      isRefilByOtherField={true}
                      placeholder={false}
                      onChange={(newValue) => handleFieldChange("underwarrenty", newValue)}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={6} md={6}>
                <CustomTextFieldWithSearch
                  label={responseType?.label == "Outsource" ? "Vendor" : "Employee"}
                  id="tc-no"
                  value={vendor}
                  options={responseType?.label == "Outsource" ? vendorOptions : employeeOptions}
                  error={!!errors?.vendor}
                  errorMessage={errors.vendor}
                  onChange={(newValue) => handleFieldChange("vendor", newValue)}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <CustomTextFieldWithSearch
                  isMandatoryField={true}
                  error={!!errors?.taskCode}
                  errorMessage={errors.taskCode}
                  label="Task Code"
                  id="tc-no"
                  value={taskCode}
                  options={taskCodeOptions?.map((item) => {

                    return {
                      ...item,
                      label: `${item?.taskcode}-${item?.label}`
                    }

                  })}
                  // })?.sort((a, b) => a.label.localeCompare(b.label))}
                  onChange={(newValue) => handleFieldChange("taskCode", newValue)}
                />
              </Grid>

              <Grid item xs={6} md={6}>
                <CustomDatePicker
                  label="Target Date"
                  isStatrtDate={true}
                  dissablePastDate={true}
                  id={"warranty-start-date"}
                  modal={open}
                  isMandatoryField={true}
                  value={targetDate}
                  error={!!errors?.targetDate}
                  errorMessage={errors.targetDate}
                  onDateChange={(newValue) => handleFieldChange("targetDate", newValue, true)}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <CustomTextField
                  onlyNumbers={true}
                  label="Scheduled Frequency"
                  //id="tc-old-no"
                  isRefilByOtherField={serviceType?.label === 'BEMS' ? ((underwarrenty === "No" && isImaging === "Yes") ? true : targetDate === undefined && (underwarrenty === "No" || underwarrenty === "Yes")) ? true : false : targetDate === undefined ? true : false}
                  value={scheduledFrequency}
                  error={!!errors?.scheduledFrequency}
                  errorMessage={errors.scheduledFrequency}
                  onChange={(newValue) => handleFieldChange("scheduledFrequency", newValue, true)}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <CustomSelectInput
                  modal={open}
                  label="Period"
                  isMandatoryField={true}
                  value={period}
                  error={!!errors?.period}
                  errorMessage={errors.period}
                  options={periodOptions}
                  disabled={serviceType?.label === 'BEMS' ? ((underwarrenty === "No"  && isImaging === "Yes") ? true : false) : false}
                  onChange={(newValue) => handleFieldChange("period", newValue)}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <CustomDatePicker
                  label="Next PPM Date"
                  isStatrtDate={true}
                  dissablePastDate={true}
                  id={"warranty-start-date"}
                  isMandatoryField={true}
                  value={nextPpmDate}
                  isDisabled={true}
                  isRefilByOtherField={true}
                  onDateChange={(newValue) => handleFieldChange("nextPpmDate", newValue)}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={handleSubmit}>
              {selectedValues?.id ? "UPDATE" : "ADD"}
            </Button>
            <Button variant="outlined" onClick={onClose}>
              CANCEL
            </Button>
          </DialogActions>
        </Dialog>


        {/* <CancelWorkOrder
          open={openCancelWO}
          onClose={(value) => setOpenCancelWO(value)}
          onConfirm={handleWoConfirm}
        /> */}

        {/* <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle>Cancel WorkOrder</DialogTitle>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={6} md={6}>
                <CustomTextField
                  label="Cancelled By"
                  id="cancelledBy"
                  name='cancelledBy'
                  //      value={cancelledBy}
                  // onChange={(e) => handleChange(e, 'cancelledBy')}
                  isMandatoryField={true}
                // error={errors.cancelledBy}
                // errorMessage={errorMessage.cancelledBy}
                />
              </Grid>
              <Grid item xs={6} md={6}>
                <CustomTextField
                  label="Reason for Cancellation"
                  id="reasonforCancellation"
                  name="reasonforCancellation"
                  //    value={reasonforCancellation}
                  //  onChange={(e) => handleChange(e, 'reasonforCancellation')}
                  isMandatoryField={true}
                // error={errors.reasonforCancellation}
                // errorMessage={errorMessage.reasonforCancellation}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary" autoFocus>
              OK
            </Button>
          </DialogActions>
        </Dialog> */}

        <CustomDialog
          open={confirmationSaveDialogOpen}
          onClose={() => setConfirmationSaveDialogOpen(false)}
          content={
            <>
              {JSON.stringify(selectedValues) === "{}"
                ? "Record created successfully"
                : "Data updated successfully"}
            </>
          }
          confirmBtn="OK"
          onConfirm={() => setConfirmationSaveDialogOpen(false)}
        />
      </>
    );
  };
  return (
    <AddRowDialogue
      selectedValues={selectedValues}
      rows={rows}
      open={showAddRowDialog}
      onClose={() => onCloseAddRowDialog(false)}
      selectedRowsisEdit={selectedRowsisEdit}
      onRowAdded={onRowAdded}
      workGroup={workGroup}
      year={year}
      serviceType={serviceType}
      facilityId={facilityId}
      approvedBy={approvedBy}
      proposedBy={proposedBy}
      companyId={companyId}
      PopPupLoading={PopPupLoading}
    />
  );
};
export default AddPPM;
